import { downloadFile } from "../utils/downloadFile";
import { API } from "./APIClient";

class LegalAPIClass {
    async fetchLegalDocumentsList() {
        const response = await API.get("/legal/list");
        const result = [];
        for (const item of response.data) {
            result.push({
                type: item.type,
                name: item.name,
            });
        }

        return result;
    }

    async downloadLegalDocument({type, name}) {
        downloadFile(`/legal/${type}`, name);
    }
}

const LegalAPI = new LegalAPIClass();
export default LegalAPI;
